'use client';

import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect, useMemo } from 'react';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';

export default function PageViewAnalytics({ page, ...data }: any) {
  const { trackEvent } = useContext(AnalyticsContext);

  const events = useMemo(() => {
    return page === 'marketing'
      ? {
          eventable: ANALYTICS_EVENTS.MARKETING.PAGE_RENDERED,
          datadog: DATADOG_EVENTS.MARKETING.PAGE_RENDERED
        }
      : {
          eventable: ANALYTICS_EVENTS.PREQUALIFIED.PAGE_RENDERED,
          datadog: DATADOG_EVENTS.PREQUALIFIED.PAGE_RENDERED
        };
  }, [page]);

  useEffect(() => {
    datadogRum.setGlobalContextProperty('page-render', `financingui-${page}`);
    datadogRum.addAction(events.datadog);
    trackEvent(events.eventable, data);
  }, [data, events.datadog, events.eventable, page, trackEvent]);

  return null;
}
